// `?error=` and `?id=` are attacker-controllable; the values render as plain
// text in the error box, which is enough for phishing without a whitelist.
const ERROR_CODE_RE = /^[a-z_]{1,40}$/
const ERROR_ID_RE = /^[a-f0-9-]{8,40}$/i

export const sanitiseErrorCode = (raw: string | null): string =>
  raw && ERROR_CODE_RE.test(raw) ? raw : 'unknown_error'

export const sanitiseErrorId = (raw: string | null): string | null =>
  raw && ERROR_ID_RE.test(raw) ? raw : null
